import React from 'react'
import { SvgIconProps } from './Home'

const SvgSendIcon = ({ fill, width, height }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? "24"}
    height={height ?? "24"}
    fill="none"
    viewBox="0 0 24 24"
  >
    <g clipPath="url(#clip0)">
      <path
        fill={fill ?? "#fff"}
        stroke={fill ?? "#fff"}
        d="M19.642 5.213l-8.214 8.215 2.143 6.285 6.071-14.5zm-9.071 7.357l8.214-8.214-14.5 6.143 6.286 2.071zm10.571-10.5c.5-.214 1.072.286.786.786l-7.857 18.786c-.214.5-1 .5-1.143 0l-2.714-7.857-7.786-2.715c-.571-.142-.571-.857-.071-1.07l18.785-7.93z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0">
        <path fill={fill ?? "#fff"} d="M0 0H20V20H0z" transform="translate(2 2)"></path>
      </clipPath>
    </defs>
  </svg>
)

export default SvgSendIcon
